import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { removeInsignificantZero } from "../../Utilities";
import { useExchangeFetch } from "../../hooks";
import { Button, FullPageLoader } from "..";
import { Toast } from "..";
export const ExchangeReview = () => {
  const {
    itemToBeReturnedTags,
    NoVariantAvailable,
    isExLoader,
    isInternalServerError,
  } = useExchangeFetch();
  const navigate = useNavigate();
  const productDetailsState = useSelector((state) => state.productDetails);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const storeConfigState = useSelector((state) => state.storeSettings);
  /*  if multiple photo upload is allowed navigate to exchange payment else upload photo  */
  const buttonHandler = () => {
    return !exchangeSettingsState.isImageUpload
      ? navigate("/ExchangePayment")
      : navigate("/photo");
  };

  /* navigate to previous page */
  const backHandler = () => {
    window.history.back();
  };

  return (
    <>
      {isExLoader ? (
        <FullPageLoader />
      ) : (
        <main className="p20 choose">
          {isInternalServerError && <Toast type="error" />}
          <div className="saara__container">
            <div className="saara-justify-content-center row__title">
              <Link to="" onClick={backHandler} width="24" className="btn__small_screen">
                <img src="assets/svg/chevron_left.svg" alt="back" />
              </Link>
              <div>
                <h1 className="p20__title saara-title">
                  {
                    storeConfigState?.themeConfig
                      ?.exchange_review_page_left_title
                  }
                </h1>
              </div>
            </div>
            <div className="saara-justify-content-center p20__row saara-d-flex">
              <div>
                <div className="exchange__card margin-right-20">
                  <span className="exchange__card_status status__old">
                    {" "}
                    {
                      storeConfigState?.themeConfig
                        ?.exchange_review_old_product_tag_label
                    }
                  </span>
                  <div className="exchange__picture">
                    <img
                      src={selectedProductDetailsState.selectedProductImage}
                      alt=""
                      className="exchange__img"
                    />
                  </div>
                  <div className="exhange__text">
                    <p className="exchange__card_desc">
                      {exchangeSettingsState.selectedProductName}
                    </p>
                    <div className="exchange__card_info">
                      <p
                        className={`${
                          !selectedProductDetailsState.selectedProductPrice &&
                          "saara-d-none"
                        }`}
                      >
                        Price:{" "}
                        <span className="exchange__card_price">
                          {productDetailsState.currency}
                          {removeInsignificantZero(
                            parseFloat(
                              selectedProductDetailsState.selectedProductPrice
                            )
                          )}
                        </span>{" "}
                      </p>
                      <span className="exchange__card_separator">
                        / {/* formatting the tags in single variable */}
                        {itemToBeReturnedTags
                          ?.substring(0, itemToBeReturnedTags?.length - 1)
                          .replace(/,/g, "/")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="exchange__card">
                  <span className="exchange__card_status status__new">
                    {
                      storeConfigState?.themeConfig
                        ?.exchange_review_new_product_tag_label
                    }
                  </span>
                  <div className="exchange__picture">
                    <img
                      src={exchangeSettingsState.newItemImage}
                      alt=""
                      className="exchange__img"
                    />
                  </div>
                  <div className="exhange__text">
                    <p className="exchange__card_desc">
                      {exchangeSettingsState.newItemName}
                    </p>
                    <div className="exchange__card_info">
                      <p
                        className={`${
                          !exchangeSettingsState.newItemPrice && "saara-d-none"
                        }`}
                      >
                        Price:{" "}
                        <span className="exchange__card_price">
                          {/* adding currency and removing zero after decimal */}
                          {productDetailsState.currency}
                          {removeInsignificantZero(
                            parseFloat(exchangeSettingsState.newItemPrice)
                          )}
                        </span>{" "}
                      </p>
                      <span
                        className={`exchange__card_separator ${
                          (!exchangeSettingsState.newItemSize ||
                            exchangeSettingsState.newItemSize === "") &&
                          "saara-d-none"
                        }`}
                      >
                        /
                      </span>
                      <p
                        className={`${
                          (!exchangeSettingsState.newItemSize ||
                            exchangeSettingsState.newItemSize === "") &&
                          "saara-d-none"
                        }`}
                      >
                        Size:{" "}
                        <span className="exchange__card_size">
                          {exchangeSettingsState.newItemSize}
                        </span>
                      </p>
                      <span
                        className={`exchange__card_separator ${
                          (!exchangeSettingsState.newItemColor ||
                            exchangeSettingsState.newItemColor === "") &&
                          "saara-d-none"
                        }`}
                      >
                        /
                      </span>
                      <p
                        className={`${
                          (!exchangeSettingsState.newItemColor ||
                            exchangeSettingsState.newItemColor === "") &&
                          "saara-d-none"
                        }`}
                      >
                        Color:{" "}
                        <span className="exchange__card_size">
                          {exchangeSettingsState.newItemColor}
                        </span>
                      </p>
                      <span
                        className={`exchange__card_separator ${
                          (NoVariantAvailable ||
                            exchangeSettingsState.newItemOtherTag ===
                              "Default Title") &&
                          "saara-d-none"
                        }`}
                      >
                        {!exchangeSettingsState.newItemOtherTag ||
                        exchangeSettingsState.newItemOtherTag === ""
                          ? ""
                          : "/"}
                      </span>
                      <p>
                        <span
                          className={`exchange__card_size ${
                            (NoVariantAvailable ||
                              exchangeSettingsState.newItemOtherTag ===
                                "Default Title") &&
                            "saara-d-none"
                          }`}
                        >
                          {exchangeSettingsState.newItemOtherTag}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="btns back-btn-exchange">
              <div className=" btn__big_screen margin-right-20">
                <button
                  className="saara_custom_btn saara__btn btn__back back_page"
                  onClick={backHandler}
                >
                  {storeConfigState?.themeConfig?.back_button_label}
                </button>
              </div>

              <div>
                <Button
                  name={storeConfigState?.themeConfig?.continue_button_label}
                  onClick={buttonHandler}
                  disabled={false}
                />
              </div>
            </div>
          </div>
        </main>
      )}
    </>
  );
};
